module.exports = __webpack_public_path__ + "img/iphone-feature-bg-02.49e8d06f.svg";